import { CardTitle, Header, PageTitle } from "../../_ui";
import labels from '../../../_translations/experts.json';
import store from "../../../_services/store";
import Card, { Container } from "./components";
import { ROUTES } from "../../../router/routes";
import { useNavigate } from "react-router-dom";

const imgUrls = [
  "/images/news2.jpeg",
  "/images/expert.jpg",
  "/images/logo_avene2.png",
  "/images/biblio.jpg"
]

const routes = [
  ROUTES.NEWS,
  ROUTES.EXPERTS,
  () => labels[store.currentLanguage].links.avene,
  ROUTES.BIBLIOGRAPHY
];

export default function InformationsPage() {
  const navigate = useNavigate();
  return (
    <div className="fadeIn" style={{ paddingBottom: '90px' }}>
      <Header bgUrl={"/images/bg-informations.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>
      </Header>
      <Container>
        {Object.keys(labels[store.currentLanguage].buttons).map(
          (key, i) => {
            const value = labels[store.currentLanguage].buttons[key].text;
            const img = imgUrls[i];
            const isAveneLogo = img === "/images/logo_avene2.png";
            return (
              <Card
                text={value}
                image={img}
                key={`item_row_${i}`}
                route={routes[i]}
                imageContain={isAveneLogo}
              />
            );
          }
        )}
        <CardTitle style={{textAlign: "center", padding: "50px", cursor:"pointer"}} onClick={() => navigate(ROUTES.LEGAL_NOTICE())}        >
          {labels[store.currentLanguage].legals}
        </CardTitle>
      </Container>
    </div>
  )
}